import { defaultProps } from "helpers/common";
import { PropsWithChildren, ReactNode } from "react";
import { Stack, StackProps, Typography, TypographyProps } from "@mui/material";

export interface TitleCardProps extends PropsWithChildren {
    title: ReactNode;
    description?: ReactNode;
    stackProps?: StackProps;
}

function TitleCard(props: TitleCardProps) {
    const stackProps = defaultProps(props.stackProps || {}, {
        sx: {
            gap: 3,
            paddingX: 2,
            paddingY: 3,
            borderRadius: 1,
            backgroundColor: "white",
            border: "1px solid #E3E9EC",
        },
    });

    const textStackProps: StackProps = {
        sx: {
            gap: 1,
        },
    };

    const titleProps: TypographyProps = {
        sx: {
            fontSize: {
                xs: 16,
                lg: 16,
            },
            fontWeight: 700,
            lineHeight: 1.2,
        },
        children: props.title,
    };

    const descriptionProps: TypographyProps = {
        sx: {
            fontSize: {
                xs: 12,
                lg: 12,
            },
            fontWeight: 500,
            color: "#7C8593",
            lineHeight: 1.2,
        },
        children: props.description,
    };

    return (
        <Stack {...stackProps}>
            <Stack {...textStackProps}>
                <Typography {...titleProps} />
                {props.description && <Typography {...descriptionProps} />}
            </Stack>
            {props.children}
        </Stack>
    );
}

export default TitleCard;
